module.exports = __webpack_public_path__ + "img/tu1.3fc332a7.jpg";